import { ReactNode } from "react";
import { Responsive } from "../../../Responsive";

export const ResponsiveContainer = (choice: 'desktop' | 'mobile' | 'breakpoint' | 'both', breakpoint?: number | "xsmall" | "small" | "medium" | "large" | "xlarge", up?: true) =>
{

    if (choice === 'desktop') return ({ children }: { children: ReactNode; }) => <Responsive desktop>{children}</Responsive>;
    else if (choice === 'mobile') return ({ children }: { children: ReactNode; }) => <Responsive mobile>{children}</Responsive>;
    else if (choice === 'breakpoint') return ({ children }: { children: ReactNode; }) => <Responsive breakpoint={breakpoint || 0} up={up}>{children}</Responsive>;
    else return ({ children }: { children: ReactNode; }) => <>{children}</>;

};
